import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import DynamicCSSVariables from './DynamicCSSVariables';
import ClientProvider from './client';
export default createDemo(import.meta.url, DynamicCSSVariables, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/how-to-customize/demos/dynamic-css-variables/DynamicCSSVariables.tsx",
    "fileName": "DynamicCSSVariables.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport { styled } from '@mui/material/styles';\nimport Slider from '@mui/material/Slider';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport Switch from '@mui/material/Switch';\n\nconst CustomSlider = styled(Slider)({\n  width: 300,\n  color: 'var(--color)',\n  '& .MuiSlider-thumb': {\n    [`&:hover, &.Mui-focusVisible`]: {\n      boxShadow: '0px 0px 0px 8px var(--box-shadow)',\n    },\n    [`&.Mui-active`]: {\n      boxShadow: '0px 0px 0px 14px var(--box-shadow)',\n    },\n  },\n});\n\nconst successVars = {\n  '--color': '#4caf50',\n  '--box-shadow': 'rgb(76, 175, 80, .16)',\n} as React.CSSProperties;\n\nconst defaultVars = {\n  '--color': '#1976d2',\n  '--box-shadow': 'rgb(25, 118, 210, .16)',\n} as React.CSSProperties;\n\nexport default function DynamicCSSVariables() {\n  const [vars, setVars] = React.useState<React.CSSProperties>(defaultVars);\n\n  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {\n    setVars(event.target.checked ? successVars : defaultVars);\n  };\n\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <React.Fragment>\n      <FormControlLabel\n        control={\n          <Switch\n            checked={vars === successVars}\n            onChange={handleChange}\n            color=\"primary\"\n            value=\"dynamic-class-name\"\n          />\n        }\n        label=\"Success\"\n      />\n      <CustomSlider style={vars} defaultValue={30} sx={{ mt: 1 }} />\n    </React.Fragment>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 53,
        "focusedLines": 14,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport { styled } from '@mui/material/styles';\nimport Slider from '@mui/material/Slider';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport Switch from '@mui/material/Switch';\n\nconst CustomSlider = styled(Slider)({\n  width: 300,\n  color: 'var(--color)',\n  '& .MuiSlider-thumb': {\n    [`&:hover, &.Mui-focusVisible`]: {\n      boxShadow: '0px 0px 0px 8px var(--box-shadow)',\n    },\n    [`&.Mui-active`]: {\n      boxShadow: '0px 0px 0px 14px var(--box-shadow)',\n    },\n  },\n});\n\nconst successVars = {\n  '--color': '#4caf50',\n  '--box-shadow': 'rgb(76, 175, 80, .16)',\n} as React.CSSProperties;\n\nconst defaultVars = {\n  '--color': '#1976d2',\n  '--box-shadow': 'rgb(25, 118, 210, .16)',\n} as React.CSSProperties;\n\nexport default function DynamicCSSVariables() {\n  const [vars, setVars] = React.useState<React.CSSProperties>(defaultVars);\n\n  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {\n    setVars(event.target.checked ? successVars : defaultVars);\n  };\n\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <React.Fragment>\n      <FormControlLabel\n        control={\n          <Switch\n            checked={vars === successVars}\n            onChange={handleChange}\n            color=\"primary\"\n            value=\"dynamic-class-name\"\n          />\n        }\n        label=\"Success\"\n      />\n      <CustomSlider style={vars} defaultValue={30} sx={{ mt: 1 }} />\n    </React.Fragment>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 38
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "React.Fragment"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 39
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "FormControlLabel"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 40
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "control"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 41
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "Switch"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 42
            },
            [
              "            ",
              [
                "span",
                "pl-e di-ak",
                "checked"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "vars"
              ],
              " ",
              [
                "span",
                "pl-k di-pu",
                "==="
              ],
              " ",
              [
                "span",
                "pl-smi di-jv",
                "successVars"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 43
            },
            [
              "            ",
              [
                "span",
                "pl-e di-ak",
                "onChange"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "handleChange"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 44
            },
            [
              "            ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "primary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 45
            },
            [
              "            ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "dynamic-class-name",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 46
            },
            "          />"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 47
            },
            [
              "        ",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 48
            },
            [
              "        ",
              [
                "span",
                "pl-e",
                "label"
              ],
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Success",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 49
            },
            "      />"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 50
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "CustomSlider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "style"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "vars"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "defaultValue"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "30"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "mt"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 51
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "React.Fragment"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 53,
    "focusedLines": 14,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/styles",
      "@mui/material/Slider",
      "@mui/material/FormControlLabel",
      "@mui/material/Switch"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
